<template>
  <div>
    <Row :gutter="12">
      <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :style="{marginBottom: '10px'}">
      <Card style="height: 50px; line-height: 50px;">
        <!--<div v-on:click.stop="gotoBack" style="cursor: pointer;">-->
          <!--<Breadcrumb separator=">" style="float: left;">-->
            <!--<img src="../assets/images/product/homework/back.png"-->
                 <!--style="margin-right: 5px;margin-left: 10px;vertical-align: text-bottom;cursor: pointer;margin-bottom: 1.5px;"/>-->
            <!--<BreadcrumbItem class="home-item">-->
                <!--返回-->
            <!--</BreadcrumbItem>-->
          <!--</Breadcrumb>-->
        <!--</div>-->
        <div class="refresh-btn click-element" @click="handleRefresh">
          <span class="refresh-ico">刷新</span>
        </div>
      </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "top-header",
    data () {
      return {
      }
    },
    methods: {
      /**
       * 返回上一页 web端暂无返回按钮
       */
      gotoBack () {
        // if (this.from == 'pc') {
        //   try {
        //     //来源与大屏 则返回作业PC端检查作业列表
        //     cef.message.sendMessage('micro.ExecFunc', ['confirmGotoHomePage', true]);
        //   } catch (e) {
        //     console.log(e);
        //   }
        // } else if (this.from == 'jsp') {
        //   //教师派
        //   this.$router.push({
        //     name: 'jspreport',
        //     params: {
        //       userId: this.$route.params.userId
        //     }
        //   });
        // } else if (this.from == 'screen') {
        //   //大屏讲评
        //   this.$router.push({
        //     name: 'reportMain',
        //     params: {
        //       userId: this.$route.params.userId
        //     }
        //   });
        // }
      },
      /**
       * 刷新
       */
      handleRefresh () {
        this.$emit('refresh-page');
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "../style/product/homework/reportList";

  .refresh-btn {
    float : right;
    margin-right : vw(64);
    margin-top: 9px;
    width         : 90px;
    height        : 30px;
    line-height   : 30px;
    text-align    : center;
    background    : #fff;
    border        : 1px solid #d9ddea;
    border-radius : 3px;
    cursor        : pointer;
    border-radius:20px;
    font-size: 16px;
    span {
      padding-left : 25px;
    }
  }

  .refresh-ico {
    background : url(../assets/images/product/homework/homework_refresh.png) no-repeat left center;
  }
</style>
